export const BffBrandType = {
	Lovet: 'LOVET',
} as const;
export type BffBrandType = (typeof BffBrandType)[keyof typeof BffBrandType];

// the following enums are used for testing
export enum FacilityServiceBrand {
	AspenDental = 'ASPEN_DENTAL',
	Invisalign = 'INVISALIGN',
	Motto = 'MOTTO',
}

export enum FacilityServiceType {
	ClearAligners = 'CLEAR_ALIGNERS',
	Implants = 'IMPLANTS',
	SpanishSpeaking = 'SPANISH_SPEAKING',
}
